import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import createEasyFirestore from 'vuex-easy-firestore'
import AccountModule from './AccountModule'
import GalleryModule from './GalleryModule'
import ItemModule from './ItemModule'
import PhotoModule from './PhotoModule'
import logEvent from './helpers'

Vue.use(Vuex)

const easyFirestores = createEasyFirestore([AccountModule, GalleryModule, ItemModule, PhotoModule], {logging: false})

export const store = new Vuex.Store(
  {
    plugins: [easyFirestores],
    state: {
      user: null
    },
    mutations: {
      login (state) {
        state.user = firebase.auth().currentUser
        logEvent({event: "login", user_id: state.user.uid})
      },
      logout (state) {
        logEvent({event: "logout", user_id: state.user.uid})
        state.user = null
        firebase.auth().signOut().then(() => {
          // Sign-out successful.
          window.location.reload()
        }, (error) => {
          // An error happened.
          console.log(error)
          window.location.reload()
        })
      }
    },
    getters: {
      getUser (state) {
        return state.user
      }
    }
  })